// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 分页查询订单列表 GET /api/v1/orders */
export async function OrderControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputOrderListItemDtoArray>(
    "/api/v1/orders",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 查询订单详情 GET /api/v1/orders/${param0} */
export async function OrderControllerGetByIdV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerGetByIdV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputOrderDto>(`/api/v1/orders/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 查看背调信息 GET /api/v1/orders/${param0}/background-check */
export async function OrderControllerBackgroundCheckV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerBackgroundCheckV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/api/v1/orders/${param0}/background-check`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 查询订单追踪记录列表 GET /api/v1/orders/${param0}/tracking-records */
export async function OrderControllerListTrackingRecordsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerListTrackingRecordsV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputOrderTrackingRecordDtoArray>(
    `/api/v1/orders/${param0}/tracking-records`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 资产绑定订单 POST /api/v1/orders/bind-asset */
export async function OrderControllerBindAssetV1(
  body: MyApi.BindAssetDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputBindAssetDto>(
    "/api/v1/orders/bind-asset",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 取消订单 POST /api/v1/orders/cancel */
export async function OrderControllerCancelV1(
  body: MyApi.CancelOrderDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputCancelOrderDto>(
    "/api/v1/orders/cancel",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 取消信用免押 POST /api/v1/orders/cancel-credit-free */
export async function OrderControllerCancelCreditFreeV1(
  body: MyApi.CancelCreditFreeDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/cancel-credit-free",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 完成订单 POST /api/v1/orders/complete */
export async function OrderControllerCompleteV1(
  body: MyApi.CompleteOrderDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>("/api/v1/orders/complete", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 完结免押订单 POST /api/v1/orders/complete-credit-free */
export async function OrderControllerCompleteCreditFreeV1(
  body: MyApi.CompleteCreditFreeDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/complete-credit-free",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 扣除押金 POST /api/v1/orders/deduct-deposit */
export async function OrderControllerDeductDepositV1(
  body: MyApi.DeductDepositDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputDeductDepositDto>(
    "/api/v1/orders/deduct-deposit",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 下载E签宝合同 GET /api/v1/orders/esign-contract */
export async function OrderControllerDownloadEsignFileV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerDownloadEsignFileV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseEsignSignedFilesDownloadDataDto>(
    "/api/v1/orders/esign-contract",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** E签宝催签 POST /api/v1/orders/esign-remind */
export async function OrderControllerEsignRemindV1(
  body: MyApi.BaseQueryOrderDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>("/api/v1/orders/esign-remind", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取E签宝签署链接 GET /api/v1/orders/esign-sign-url */
export async function OrderControllerGetEsignSignUrlV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerGetEsignSignUrlV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseEsignSignUrlDataDto>(
    "/api/v1/orders/esign-sign-url",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 强制解绑 POST /api/v1/orders/force-unbind */
export async function OrderControllerForceUnbindV1(
  body: MyApi.ForceUnbindDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>("/api/v1/orders/force-unbind", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取赋强公证公证书链接 GET /api/v1/orders/notary-cert-url */
export async function OrderControllerGetNotaryCertUrlV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerGetNotaryCertUrlV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseString>("/api/v1/orders/notary-cert-url", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 押金线下入账 POST /api/v1/orders/offline-deposit-payment */
export async function OrderControllerOfflineDepositPaymentV1(
  body: MyApi.OfflineDepositPaymentDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentRecordDto>(
    "/api/v1/orders/offline-deposit-payment",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 押金线下退款 POST /api/v1/orders/offline-deposit-refund */
export async function OrderControllerOfflineDepositRefundV1(
  body: MyApi.OfflineDepositRefundDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/offline-deposit-refund",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 线下入账 POST /api/v1/orders/offline-payment */
export async function OrderControllerOfflinePaymentV1(
  body: MyApi.OfflinePaymentDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentRecordDto>(
    "/api/v1/orders/offline-payment",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 线下退款 POST /api/v1/orders/offline-refund */
export async function OrderControllerOfflineRefundV1(
  body: MyApi.OfflineRefundDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/offline-refund",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 线上支付的账单退款 POST /api/v1/orders/online-bill-refund */
export async function OrderControllerOnlineBillRefundV1(
  body: MyApi.OnlineBillRefundDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/online-bill-refund",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 线上支付的账单退款查询 GET /api/v1/orders/online-bill-refund-query */
export async function OrderControllerOnlineBillRefundQueryV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerOnlineBillRefundQueryV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/online-bill-refund-query",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 用户线上支付的押金退款 POST /api/v1/orders/online-deposit-refund */
export async function OrderControllerOnlineDepositRefundV1(
  body: MyApi.OnlineDepositRefundDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/online-deposit-refund",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 线上支付的押金退款查询 GET /api/v1/orders/online-deposit-refund-query */
export async function OrderControllerOnlineDepositRefundQueryV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerOnlineDepositRefundQueryV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/online-deposit-refund-query",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 在线扣款 POST /api/v1/orders/online-payment */
export async function OrderControllerOnlinePaymentV1(
  body: MyApi.OnlinePaymentDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentRecordDto>(
    "/api/v1/orders/online-payment",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 在线扣款查询 GET /api/v1/orders/online-payment-query */
export async function OrderControllerOnlinePaymentQueryV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerOnlinePaymentQueryV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputOnlinePaymentQueryDto>(
    "/api/v1/orders/online-payment-query",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 同步E签宝签署流程状态 POST /api/v1/orders/sync-esign-flow-status */
export async function OrderControllerSyncEsignFlowStatusV1(
  body: MyApi.SyncEsignFlowStatusDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputSyncEsignFlowStatusDto>(
    "/api/v1/orders/sync-esign-flow-status",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 手动同步赋强公证结果 POST /api/v1/orders/sync-notary-result */
export async function OrderControllerSyncNotaryResultV1(
  body: MyApi.BaseQueryOrderDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseNotaryInfoDto>(
    "/api/v1/orders/sync-notary-result",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 创建订单追踪记录 POST /api/v1/orders/tracking-records */
export async function OrderControllerCreateTrackingRecordV1(
  body: MyApi.CreateOrderTrackingRecordDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputOrderTrackingRecordDto>(
    "/api/v1/orders/tracking-records",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 修改订单押金金额 POST /api/v1/orders/update-deposit */
export async function OrderControllerUpdateDepositV1(
  body: MyApi.UpdateDepositDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputUpdateDepositDto>(
    "/api/v1/orders/update-deposit",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 商家上传凭证 POST /api/v1/orders/upload-attachments */
export async function OrderControllerUploadAttachmentsV1(
  body: MyApi.UploadAttachmentsDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/upload-attachments",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
